export default "__VITE_ASSET__fd6c2bec__"